import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { distance as formatDistance } from 'src/domains/sportsbook/utils/format';
import { RacecardRaceRouteType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import {
    CardHeaderRaceName,
    CardHeaderRaceMeta,
    CardHeaderStreamIco,
    CardHeaderWrapper,
    CardHeaderData,
} from 'src/domains/sportsbook/webview/components/raceSliderItemV1/shared/cardHeader/CardHeader.style';
import { StreamingState } from 'src/domains/sportsbook/state/streamingState/StreamingState';

export interface CardHeaderPropsType {
    race: EventModel;
    routingData: RacecardRaceRouteType;
}

export const CardHeader = observer('CardHeader', (props: CardHeaderPropsType) => {
    const { race, routingData } = props;
    const common = useCommon();
    const { config } = ConfigComponents.get(common);
    const streamingState = StreamingState.get(common);
    const distance = formatDistance(race.feedDistance);

    const [raceHourPart, ...racePlaceParts] = race.name.split(' ');
    const racePlace = racePlaceParts.join(' ');
    const raceHour = raceHourPart ?? '';

    const hasStream = config.hasEventLiveStreaming && streamingState.hasStream(race.id2.toOldId());

    return (
        <CardHeaderWrapper
            dataTest='event'
            to={routingData}
            key='race-box__header-link'
        >
            {hasStream && <CardHeaderStreamIco />}

            <CardHeaderData>
                {racePlace !== '' && <CardHeaderRaceName>{racePlace}</CardHeaderRaceName>}

                {raceHour !== '' && <CardHeaderRaceMeta>{raceHour}</CardHeaderRaceMeta>}

                {distance !== '' && <CardHeaderRaceMeta>{distance}</CardHeaderRaceMeta>}
            </CardHeaderData>
        </CardHeaderWrapper>
    );
});
